<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles overApplication">
            <van-nav-bar
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
                @click-right="onClickRight"
            >
                <template #title>
                    <div
                        :class="{'active': listType == 'transfinite'}"
                        @click="listSwitch('transfinite')"
                    >
                        超限合同
                    </div>
                    <div
                        :class="{'active': listType == 'transfiniteTemp'}"
                        @click="listSwitch('transfiniteTemp')"
                    >
                        暂存箱
                    </div>
                </template>
                <template #right>
                    <van-icon name="plus" size="18"></van-icon>
                </template>
            </van-nav-bar>
            <section>
                <van-search
                    v-model="keywords"
                    placeholder="请输入搜索信息"
                    @search="search"
                    v-if="listType==='transfinite'"
                ></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :style="{height:listType!=='transfinite'?'100%':'calc(100% - 40rpx)'}">
                    <template v-if="listType==='transfinite'">
                        <van-list
                            v-model="isUpLoading"
                            :finished="finished"
                            finished-text="没有更多了!"
                            @load="onLoad"
                            :immediate-check="false"
                        >
                            <ul class="list">
                                <template>
                                    <li
                                        class="retail"
                                        v-for="item in transfiniteList"
                                        :key="item.ctsid"
                                        @click="transfiniteInfo(item)"
                                    >
                                        <div class="engineeringInfo">
                                            <h4 class="engineeringInfo_header">
                                                <span
                                                    class="state lssx"
                                                    v-if="item.contract_type_name==='临时赊销合同'"
                                                >
                                                    <i>{{ item.contract_type_name|typeParse }}</i>
                                                </span>
                                                <span
                                                    class="state xianx"
                                                    v-else-if="item.contract_type_name==='现销合同'"
                                                >
                                                    <i>{{ item.contract_type_name|typeParse }}</i>
                                                </span>
                                                <span
                                                    class="state lings"
                                                    v-else
                                                >
                                                    <i>{{ item.contract_type_name|typeParse }}</i>
                                                </span>
                                                <span class="headerName">工程名称：{{ item.engineering_name }}</span>
                                                <span class="contractStatus contractStatus0" v-if="item.approval_status===0">未审批</span>
                                                <span class="contractStatus contractStatus1" v-else-if="item.approval_status===1">审批中</span>
                                                <span class="contractStatus contractStatus2" v-else-if="item.approval_status===2">审批通过</span>
                                                <span class="contractStatus contractStatus3" v-else-if="item.approval_status===3">审批未通过</span>
                                            </h4>
                                            <div class="engineeringInfo_content">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                    <span>合同编号：{{ item.contract_number }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                    <span>客户名称：{{ item.client_name }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                    <span>超发申请时间：{{ item.application_time }}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                </template>
                            </ul>
                        </van-list>
                    </template>
                    <template v-else>
                        <ul class="list list2" v-if="transfiniteTempList.length>0">
                            <template>
                                <li
                                    class="retail"
                                    v-for="item in transfiniteTempList"
                                    :key="item.ctsid"
                                    @click="modifyTransfinite(item)"
                                >
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span
                                                class="state lssx"
                                                v-if="item.contract_type_name==='临时赊销合同'"
                                            >
                                                <i>{{ item.contract_type_name|typeParse }}</i>
                                            </span>
                                            <span
                                                class="state xianx"
                                                v-else-if="item.contract_type_name==='现销合同'"
                                            >
                                                <i>{{ item.contract_type_name|typeParse }}</i>
                                            </span>
                                            <span
                                                class="state lings"
                                                v-else
                                            >
                                                <i>{{ item.contract_type_name|typeParse }}</i>
                                            </span>
                                            <span class="headerName">工程名称：{{ item.engineering_name }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                <span>合同编号：{{ item.contract_number }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                <span>客户名称：{{ item.client_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>超发申请时间：{{ item.application_time }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                        <div class="no-data" v-if="showTempDefault">
                            没有更多了！
                        </div>
                    </template>
                </van-pull-refresh>
            </section>
            <!-- 加载层 -->
            <van-overlay :show="showOverlay">
                <van-loading type="spinner"></van-loading>
            </van-overlay>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 超发申请
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'over-application');
        }
        next();
    },
    name: 'over-application',
    components: {},
    props: {},
    data() {
        return {
            value: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否已加载完所有数据
            finished: false,
            // 列表类型
            listType: 'transfinite',
            // 分页
            page: {
                pageindex: 1,
                pagesize: 5,
            },
            // 搜索关键词
            keywords: '',
            // 超限列表
            transfiniteList: [],
            // 暂存箱
            transfiniteTempList: [],
            showTempDefault: false,
            // 加载层
            showOverlay: false,
        };
    },
    filters: {
        typeParse(value) {
            let str = '';
            if (value) {
                str = value.substr(0, 2);
            }
            return str;
        },
    },
    computed: {},
    watch: {},
    activated() {
        this.showOverlay = true;
        if (this.listType === 'transfinite' || this.$route.params.isRefresh) {
            this.page.pageindex = 1;
            this.transfiniteList = [];
            this.finished = false;
            this.getTransfinite();
        } else {
            this.getTransfiniteTemp();
        }
    },
    created() {},
    mounted() {
        // this.getTransfinite();
    },
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 新增
        onClickRight() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'overrunDeliverGoodsForm',
                params: {
                    type: 'new',
                },
            });
        },
        // 修改
        modifyTransfinite(data) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'overrunDeliverGoodsForm',
                params: {
                    type: 'modify',
                    listData: data,
                },
            });
        },
        // 详情
        transfiniteInfo(data) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'overrunDeliverGoodsForm',
                params: {
                    type: 'modify',
                    listData: data,
                    isReadOnly: true,
                },
            });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        search() {
            this.page.pageindex = 1;
            this.transfiniteList = [];
            this.finished = false;
            this.getTransfinite();
        },
        // 下拉刷新
        onRefresh() {
            this.isLoading = false;
            if (this.listType === 'transfinite') {
                this.page.pageindex = 1;
                this.transfiniteList = [];
                this.finished = false;
                this.getTransfinite();
            } else {
                this.getTransfiniteTemp();
            }
        },
        // 上拉加载更多
        onLoad() {
            setTimeout(() => {
                this.page.pageindex++;
                this.getTransfinite();
            }, 0);

        },
        // 切换列表
        listSwitch(type) {
            this.showOverlay = true;
            this.listType = type;
            if (type === 'transfinite') {
                this.page.pageindex = 1;
                this.transfiniteList = [];
                this.finished = false;
                this.getTransfinite();
            } else {
                this.getTransfiniteTemp();
            }
        },
        // 分页拉取超发申请
        getTransfinite() {
            const queryStr = '?keywords=' + this.keywords + '&pageindex=' + this.page.pageindex + '&pageSize=' + this.page.pagesize;
            this.$axios
                .get('/interfaceApi/sale/contract_transfinite/get_page' + queryStr)
                .then(res => {
                    if (res) {
                        this.isLoading = false;
                        this.isUpLoading = false;
                        if (res.total) {
                            this.transfiniteList = this.transfiniteList.concat(res.rows);
                            if (this.transfiniteList.length >= res.total) {
                                this.finished = true;
                            }
                        } else {
                            this.finished = true;
                        }
                        this.showOverlay = false;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                    this.showOverlay = false;
                });
        },
        // 拉取暂存箱
        getTransfiniteTemp() {
            this.$axios
                .get('/interfaceApi/sale/contract_transfinite/get_temp')
                .then(res => {
                    if (res) {
                        this.transfiniteTempList = res;
                        if (res.length < 1) {
                            this.showTempDefault = true;
                        }
                        this.showOverlay = false;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                    this.showOverlay = false;
                });
        },
    },
};
</script>
<style lang="stylus">
.overApplication
    height 100%
    background #F0F0F0
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
    section
        height calc(100% - 45rpx)
        overflow: hidden;
        background: #f0f0f0;
        .van-pull-refresh
            height calc(100% - 40rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            background: #f0f0f0;
            .van-pull-refresh__track
                height 100%
            .van-list
                height 100%
                background #f0f0f0
            .no-data
                text-align center
                font-size 14rpx
                color #969799
                padding-top 20rpx
            .list
                li
                    width 100%
                    background #fff
                    margin-bottom 15rpx
                    .engineeringInfo
                        .contractStatus
                            font-weight 400
                            font-size 12rpx
                            color #00A84B
                            text-align right
                            white-space: nowrap
                            padding 0 8rpx
                        .contractStatus0
                            color #FF6600
                        .contractStatus1
                            color #0101B5
                        .contractStatus2
                            color #00A84B
                        .contractStatus3
                            color #D6010F
                    &.retail
                        h4
                            .state
                                background-color #FF6600
                    &.formal
                        h4
                            .state
                                background-color #E60000
                    &.temporary
                        h4
                            .state
                                background-color #191990
</style>